import { Column, RowData, SortDirection } from '@tanstack/react-table';
import { ReactComponent as ArrowsInactiveIcon } from 'assets/icons/sorting/ArrowsInactive.svg';
import { ReactComponent as ArrowsAscendingIcon } from 'assets/icons/sorting/ArrowsAscending.svg';
import { ReactComponent as ArrowsDescendingIcon } from 'assets/icons/sorting/ArrowsDescending.svg';
import cn from 'classnames';
import styles from './SortingControls.module.css';

type Props = {
    activeSort: SortDirection | false;
};

const SortingControls = ({ activeSort }: Props) => {
    const Icon = !activeSort ? ArrowsInactiveIcon : activeSort === 'asc' ? ArrowsAscendingIcon : ArrowsDescendingIcon;
    return <Icon className={cn(styles.sortingIcon, { [styles.sortingActive]: Boolean(activeSort) })} />;
};

export default SortingControls;

// Helper to map sort controls component to the expected table prop signature
export const renderSortingControls = <T extends RowData>(column: Column<T, unknown>) => {
    return <SortingControls activeSort={column.getIsSorted()} />;
};
